import { topicList } from "@/mocks/homeData";
import { SectionHead } from "./kit";

export default function Topics() {
  return (
    <section id="topics" className="mx-auto max-w-6xl px-4 py-7 md:px-6 md:py-10">
      <SectionHead
        kicker="SPECIAL COLLECTIONS"
        title="专题合集 · 按话题归档"
        tone="secondary"
        extra={
          <span className="hidden items-center gap-1.5 text-xs text-foreground-400 md:inline-flex">
            每个专题配独立档案编号，随时跟进补齐
            <i className="ri-folder-history-line text-secondary-600" />
          </span>
        }
      />

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
        {topicList.map((t) => (
          <article
            key={t.name}
            className="group relative cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100"
          >
            <div className="relative aspect-[4/3] w-full overflow-hidden">
              <img
                src={t.img}
                alt={t.name}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/20 to-transparent" />
              <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-foreground-800">
                <i className="ri-archive-2-line text-secondary-700" />
                {t.count}
              </span>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-4 text-background-50 md:p-5">
              <h3 className="font-heading text-lg font-bold md:text-xl">{t.name}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-50/75 md:text-[13px]">
                {t.desc}
              </p>
              <button
                type="button"
                className="mt-3 inline-flex cursor-pointer items-center gap-1 rounded-full bg-background-50/95 px-3 py-1.5 text-xs font-semibold text-foreground-900 whitespace-nowrap transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                进合集浏览
                <i className="ri-arrow-right-line text-xs" />
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}